import Dashboard from "../../views/admin/dashboard";
import Login from "../../views/admin/Login/index";



import CreateProperty from "../../views/admin/Property/CreateProperty/index"
import PropertyList from "../../views/admin/Property/PropertyList/index"
import PropertyDetails from "../../views/admin/Property/PropertyDetails";
import UpdateProperty from "../../views/admin/Property/UpdateProperty";



import AccountSetting from "../../views/AccountSetting";

import AgentListing from "../../views/admin/Agent/index"
import InvestorList from "../../views/admin/Investors/InvestorList";
import InvestorCreate from "../../views/admin/Investors/InvestorCreate";
import EditInvestor from "../../views/admin/Investors/EditInvestor";
import BookingList from "../../views/admin/Booking/BookingList";
import BookingApproved from "../../views/admin/Booking/ApprovedBooking/index";
import ApprovedAgent from "../../views/admin/Agent/ApprovedAgent";
import AgentDetail from "../../views/admin/Agent/AgentDetail";
import AgentReport from "../../views/admin/Agent/AgentReport";
import PropertyAnalytics from "../../views/admin/Property/PropertyList/propertyAnalytics";
import RequestListing from "../../views/admin/RequestListing";
import ApprovedAgentRequestListing from "../../views/admin/RequestListing/ApprovedAgentRequestListing";
import ClosedDeals from "../../views/admin/Property/PropertyList/closeDeal";
import ViewSheet from "../../views/admin/Property/PropertyList/viewSheet";

const AdminRoutes = [
  {
    path: "/login",
    component: <Login />
  },
  {
    path: "/dashboard",
    component: <Dashboard />
  },
 
  
  
 
  {
    path: "/properties",
    component: <PropertyList />
  },
  {
    path: "/properties/create",
    component: <CreateProperty />
  },
  {
    path: "/properties/update/:id",
    component: <UpdateProperty/>
  },
  {
    path: "/properties/details/:id",
    component: <PropertyDetails/>
  },
  {
    path: "/property/report",
    component: <PropertyAnalytics />
  },
 
 
  {
    path: "/account/setting",
    component: <AccountSetting />
  },
 {

  path: "/agent/list",
  component: <AgentListing />
 },
 {

  path: "/agent/detail/:id",
  component: <AgentDetail />
 },
 {

  path: "/approved-agent/list",
  component: <ApprovedAgent />
 },
 {
  path: "/agent/report",
  component: <AgentReport />
 },
 {

  path: "/investor/list",
  component: <InvestorList />
 },
 {

  path: "/investor/create",
  component: <InvestorCreate />
 },
 {

  path: "/investor/update/:id",
  component: <EditInvestor />
 },
 {

  path: "/booking/list",
  component: <BookingList />
 },
 {

  path: "/approved/list",
  component: <BookingApproved />
 },
 {
    path: "/request/list",
    component: <RequestListing />
  },
  {
    path: "/approved-request/list",
    component: <ApprovedAgentRequestListing />
  },
  {
    path: "/closed-deals/list",
    component: <ClosedDeals />
  },
  {
    path: "/property/view-sheet",
    component: <ViewSheet />
  }
];

export default AdminRoutes;